import React,{useState,useEffect} from 'react'
import {Box, DataTable,Button } from 'grommet'
import { withRouter } from 'react-router-dom';
import { Add } from 'grommet-icons';
import { TableLoadLayer, NavigationSnackBar } from '../../components/utils/shared/shared';
import {APIRequest} from '../../components/utils/shared/requests'
import {ShipmentSuccessNotification} from '../../components/utils/shared/shipmentViewFunctions'

function AddressBook (props) {
    const [addresses, setAddresses] = useState([]);
    const [addressSucc, setAddressSucc] = useState(props.location.labSucc)
    const [load, setLoad] = useState(true)
    useEffect(() => {     
      APIRequest('/addresses').then(result => {setAddresses(result); setLoad(false)})
      setTimeout(() => {
        setAddressSucc(undefined);
      }, 5000)
     },[]);
  return (
   <Box wrap flex="grow">
      <NavigationSnackBar title={'Address Book'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
      {addressSucc && (<ShipmentSuccessNotification label={"Lab"} edit={props.location.edit} />)}
     <Box direction='row' justify='end'>
        <Button primary label='Create Address' margin='small' icon={<Add />} hoverIndicator onClick={() => props.history.push('/addresses/create')}/>
      </Box>
      <Box margin='medium' pad='small' elevation="medium" overflow='scroll' round>
       
      <DataTable background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }}} paginate step={10} pad={{ horizontal: 'xsmall', vertical: 'small' }} margin='xsmall' columns={[ {header:"ID",property:"id",primary:true,sortable:true,search:false}, {header:"Name",property:"name", search:true}, {header:"Country",property:"address.Country.CountryName",sortable:true,search:false}]}  onClickRow={({datum}) => {props.history.push({pathname:`/addresses/edit/${datum.id}`})}} data={addresses} />
      {load && (<TableLoadLayer load={load} label={"Loading Addresses..."} />)}
        </Box>
   </Box>
  )
}

export default withRouter(AddressBook)
